
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { TIMEZONES, TIMEZONE_KEY_IN_LS } from '../constants';
import { getTimezone } from '../selectors/common';
import { aSetTimezone } from '../reducers/common';

const mapToProps = (state) => ({
  getTimezone: getTimezone(state),
});

const actionsToProps = (dispatch) => ({
  setTimezone: (payload) => dispatch(aSetTimezone(payload)),
});

class Timezone extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownOpen: false,
    };
  }

  componentDidMount() {
    this.getTimezoneFromLS();
  }

  getTimezoneFromLS = () => {
    const timezone = localStorage.getItem(TIMEZONE_KEY_IN_LS);
    if (!timezone) {
      this.props.setTimezone({ timezone: TIMEZONES.UTC });
    } else {
      this.props.setTimezone({ timezone });
    }
  };

  toggleDropdown = () => {
    this.setState({
      dropDownOpen: !this.state.dropDownOpen,
    });
  };

  changeTimezone = (newTimezone) => {
    this.props.setTimezone({ timezone: newTimezone });
    localStorage.setItem(TIMEZONE_KEY_IN_LS, newTimezone);
    this.setState({
      dropDownOpen: false,
    });
  };

  render() {
    return (
      <div
        className="time-zone"
        onClick={this.toggleDropdown}
      >
        <div className={`time-zone__holder ${this.state.dropDownOpen && 'is-open'}`}>
          <div className="time-zone__wrap">
            <div className="time-zone__label">Time Zone:</div>
            <div className="time-zone__value">{this.props.getTimezone}</div>
          </div>
          <div className="time-zone__list">

            {Object.keys(TIMEZONES).map((key) => (
              <div
                key={key}
                className={`time-zone__list-item ${this.props.getTimezone === TIMEZONES[key] && 'active'}`}
                onClick={() => this.changeTimezone(TIMEZONES[key])}
              >
                {TIMEZONES[key]}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapToProps, actionsToProps)(Timezone);
